export default __webpack_public_path__ + "static/ipad-3column-6fec1f4a3e4f1f7600f7debc3648af29.png";